import api from "./api";

const DashboardAPI = {
    getDatas: (id) => api.get(`/dashboard/data/all`)
};

export default DashboardAPI;